import { render } from "./ReposView.vue?vue&type=template&id=cc021432"
import script from "./ReposView.vue?vue&type=script&lang=js"
export * from "./ReposView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/PIPIPIG233666.github.io/PIPIPIG233666.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__